import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import TableLayout from "../../../component/atoms/layout/table/tableLayout";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
// import PostApi from "../../../api/post.api";
import moment from "moment";
import { toast } from "react-toastify";
import DetailBtn from "../../../component/atoms/button/detailBtn";
import TableDelBtn from "../../../component/atoms/button/tableDelBtn";
import SearchBar from "../../../component/atoms/input/searchBar";
import Table from "../../../component/atoms/layout/table/table";
import TableSearchBtn from "../../../component/atoms/layout/table/tableSearchBtn";
import TableTop from "../../../component/atoms/layout/table/tableTop";
import Td from "../../../component/atoms/layout/table/td";
import Th from "../../../component/atoms/layout/table/th";
import Tr from "../../../component/atoms/layout/table/tr";
import TableText from "../../../component/atoms/text/table/tableText";
import Pagination from "../../../component/molecules/pagination";
import TableCount from "../../../component/molecules/tableCount";
import TableTab02 from "../../../component/molecules/tableTab02";
import Modal from "../../../component/templates/Modal";
import { route } from "../../../router/route";
import { errorHandler } from "../../../util/errorHandler";
import { modalMsg } from "../../../util/modalMsg";
import { toastMsg } from "../../../util/toastMsg";
import CommunityApi from "../../../api/community.api";

const CommentReport = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const tabList = [
    {
      title: "게시글",
      link: route.community_report_post,
      originLink: route.community_report_post,
    },
    {
      title: "댓글",
      link: route.community_report_comment,
      originLink: route.community_report_comment,
    },
  ];

  // mounted
  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    getReportList();
  }, [location]);

  // ----- 목록 가져오기
  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
  });

  const [postList, setPostList] = useState([]);
  const [keyword, setKeyword] = useState("");

  const getReportList = async () => {
    try {
      const data = {
        keyword: searchParams.get("keyword"),
        page: searchParams.get("page"),
        size: pagination.size,
        postFlag: "Inactive",
      };
      let responseData = (await CommunityApi.getReport(data)).data.data;

      setPostList(
        responseData.content.map((item) => {
          return {
            ...item,
            checked: false,
          };
        })
      );
      setPagination({
        ...pagination,
        totalCount: responseData.totalCount ? responseData.totalCount : 0,
        totalPages: Math.ceil(responseData.totalCount / pagination.size),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 삭제
  const [delIdList, setDelIdList] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteFunc = async () => {
    try {
      await CommunityApi.delReport(delIdList[0]);
      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      setDelIdList([]);
      getReportList();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <TableLayout>
          <TableTitle>신고 관리</TableTitle>
          <TableTop>
            <TableCount text={"항목"} count={pagination.totalCount} />
            <TableSearchBtn>
              <SearchBar
                value={keyword}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    navigate(
                      `${route.community_report_comment}?page=1&keyword=${encodeURIComponent(
                        keyword
                      )}`,
                      {
                        replace: true,
                      }
                    );
                  }
                }}
                onClick={() => {
                  navigate(
                    `${route.community_report_comment}?page=1&keyword=${encodeURIComponent(
                      keyword
                    )}`,
                    {
                      replace: true,
                    }
                  );
                }}
              />
            </TableSearchBtn>
          </TableTop>
          <TableTab02 list={tabList} style={{ marginBottom: "20px" }} />
          <Table>
            <colgroup>
              <col width="157px" />
              <col width="580px" />
              <col width="138px" />
              <col width="95px" />
              <col width="73px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "40px", background: "#f2f4f5" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <TableText>게시자</TableText>
                </Th>
                <Th>
                  <TableText>신고사유</TableText>
                </Th>
                <Th>
                  <TableText>신고일</TableText>
                </Th>
                <Th>
                  <TableText>삭제하기</TableText>
                </Th>
                <Th>
                  <TableText>상세보기</TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {postList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{ height: "59px", background: "#fff" }}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <TableText>
                        {item.communityComment?.member?.nickname}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText>{item.reason}</TableText>
                    </Td>
                    <Td>
                      <TableText>
                        {moment.utc(item.createdAt).format("YYYY/MM/DD")}
                      </TableText>
                    </Td>
                    <Td>
                      <TableDelBtn
                        onClick={() => {
                          setPostList([...postList]);
                          const delList = [item];
                          setDelIdList(delList.map((item) => item.id));
                          setDeleteModalOpen(true);
                        }}
                      />
                    </Td>

                    <Td>
                      <DetailBtn
                        onClick={() => {
                          navigate(
                            route.community_report_comment_detail +
                              `/${item.id}`
                          );
                        }}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          <Pagination
            route={route.community_report_comment}
            queryString={`keyword=${encodeURIComponent(
              searchParams.get("keyword") || ""
            )}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
          />
        </TableLayout>
      </MainLayout>

      {deleteModalOpen ? (
        <Modal
          negative
          title={modalMsg.delete?.title}
          text={modalMsg.delete?.content}
          btnTitle={"삭제하기"}
          setModalOpen={setDeleteModalOpen}
          onClick={() => {
            deleteFunc();
          }}
        />
      ) : null}
    </>
  );
};
export default CommentReport;
